<template>
  <div class="containd">
    <div class="contain-top">
      <!-- <img src="../../../../assets/image/icon_left.png" alt=""> -->
      <span>{{
        type == 1 ? "随堂练习" : type == 2 ? "课后作业" : "班级考试"
      }}</span>
    </div>
    <div class="exam" v-loading="loading" element-loading-text="拼命加载中">
      <div class="exam-list">
        <div class="exam-box" v-for="(item, index) in list" :key="index">
          <div class="exam-box-left">
            <p>{{ item.name }}</p>
            <div class="exam-box-left-msg">
              <div class="msg-box">
                【老师】
                <span>{{ item.teacher.name }}</span>
              </div>
              <div class="msg-box">
                【题目】
                <span>{{ item.question_num }}</span>
              </div>
              <div class="msg-box">
                【总分】
                <span>{{ item.total_score }}</span>
              </div>
              <div class="msg-box">
                【状态】
                <span>{{
                  !item.last_student_answer_log
                    ? "未考试"
                    : item.last_student_answer_log.is_score == 0
                    ? "已考试"
                    : "已评分"
                }}</span>
              </div>
              <div v-if="item.last_student_answer_log">
                <div
                  class="msg-box"
                  v-if="item.last_student_answer_log.is_commit == 1"
                >
                  【分数】
                  <span class="span">{{
                    item.last_student_answer_log.is_score == 0
                      ? "未评分"
                      : item.last_student_answer_log.score
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <el-button
              type="primary"
              v-if="!item.last_student_answer_log || !item.last_student_answer_log.is_commit"
              @click="goExam(item.id)"
              >开始考试</el-button
            >
            <el-button type="primary" v-else @click="goDetail(item.id)">
              查看详情
            </el-button>
          </div>
        </div>
      </div>
      <noData v-if="noData && !loading"></noData>
      <p class="p" v-if="noMore && !noData">已经到底了~</p>
    </div>
  </div>
</template>
<script>
import forumComment from "@/components/forum-comment/index.vue";
import request from "@/utils/request";
import { diffTime } from "@/utils/common.js";
import loading from "@/components/loading/loading.vue";
import noData from "@/components/noData/index.vue";
import Cookies from "js-cookie";
export default {
  components: { forumComment, loading, noData },
  data() {
    return {
      noData: false,
      loading: false,
      list: [],
      total: 0,
      query: {
        page: 1,
        limit: 10,
        type: 1,
      },
      noMore: false,
      num: 0,
      type: 1,
    };
  },
  mounted() {
    if (Cookies.get("Admin-Token")) {
      this.getList();
    }
    window.addEventListener("scroll", this.handleScroll); // 监听（绑定）滚轮滚动事件
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
  },
  watch: {
    "$route.query.type"(newValue, old) {
      this.type = newValue;
      this.query.type = newValue;
      this.getList();
    },
  },
  created() {
    this.type = this.$route.query.type;
    this.query.type = this.$route.query.type;
    this.getList();
  },
  methods: {
    goDetail(id) {
      this.$router.push({
        path: "/mine/my_study/question_bank/exam_details",
        query: {
          teacher_paper_id: id,
        },
      });
    },
    goExam(id) {
      this.$router.push({
        path: "/mine/my_study/question_bank/start_exam",
        query: {
          teacher_paper_id: id,
        },
      });
    },
    back() {
      this.$router.push("/mine/my_study/question_bank");
    },
    handleScroll() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        if (!this.noMore) {
          console.log("触底");
          this.query.limit += 10;
          this.getList();
        }
        //写后台加载数据的函数
        // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
      }
    },
    //试卷
    getList() {
      this.noData = false;
      this.loading = true;
      request({
        url: "/api/userend/paper/list",
        method: "get",
        params: this.query,
      }).then((response) => {
        this.list = response.data;
        this.total = response.data.length;
        if (this.total == 0) {
          this.noData = true;
        }
        if (this.list.length < this.query.limit) {
          this.noMore = true;
        }
        this.loading = false;
        this.$forceUpdate(); //强制更新
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.containd {
  background: #ffffff;
  border-radius: 16upx;
  padding: 30px;
  .contain-top {
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img {
      width: 15px;
      height: 15px;
    }
    span {
      margin-left: 10px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #506176;
    }
  }
  .height4 {
    height: 100vh;
  }
  .exam {
    background: #ffffff;
    // padding: 0 30px;
    border-radius: 8px;
    .p {
      text-align: center;
      padding: 5px 0 10px 15px;
    }
    .exam-list {
      .exam-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0;
        border-bottom: 1px solid #f9fafd;
        .exam-box-left {
          p {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
          }
          .exam-box-left-msg {
            display: flex;
            justify-content: flex-start;
            .msg-box {
              margin-right: 30px;
              font-size: 18px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              text {
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }
              .span {
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #f24342;
              }
            }
          }
        }
      }
    }
  }
  .el-loading-spinner {
    position: fixed;
    top: 400px;
    left: 230px;
  }
}
</style>